import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const MindLynq = () => <AppShell app={getApp("mindlynq")} />;

export default MindLynq;
